import React from 'react';
import { Box, Typography, Stack, Divider } from '@mui/material';
import { LeadRow } from './LeadRow';
import type { LeadListItem } from '@/api/leads';

interface LeadsTableProps {
  items: LeadListItem[];
  onRowClick: (uuid: string) => void;
}

export const LeadsTable: React.FC<LeadsTableProps> = ({ items, onRowClick }) => {
  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '2.1fr 1.4fr 1fr 1.3fr 1.8fr 2.3fr 0.6fr',
          gap: 1,
          alignItems: 'center',
          pb: 1.5,
          borderBottom: 1,
          borderColor: 'divider',
          mb: 1,
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          Prospect
        </Typography>
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          Title
        </Typography>
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          Location
        </Typography>
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          Current Company
        </Typography>
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          Step Categories
        </Typography>
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          Activities
        </Typography>
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, color: 'text.secondary', textAlign: 'right' }}
        >
          Actions
        </Typography>
      </Box>

      {/* Rows with separators */}
      <Stack divider={<Divider flexItem />} spacing={0}>
        {items.map((item) => (
          <LeadRow key={item.key} item={item} onRowClick={onRowClick} />
        ))}
      </Stack>
    </Box>
  );
};

